import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AskAnalystPanel from './AskAnalystPanel';

/** Renders Ask Analyst panel when user is authenticated. */
export default function AskAnalystGate() {
  const { token, loading } = useAuth();
  if (loading || !token) return null;
  return <AskAnalystPanel />;
}
